module.exports = __webpack_public_path__ + "public/Icons/manage_fare.svg?4e677092";